import { useEffect, useState, useCallback } from "react";
import api from "@/lib/api";
import PageHeader from "@/components/PageHeader";
import {
  Table, TableBody, TableCell, TableHead, TableHeader, TableRow,
} from "@/components/ui/table";
import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from "@/components/ui/select";
import { Label } from "@/components/ui/label";
import { Activity as ActivityIcon } from "lucide-react";
import DataTable from "@/components/DataTable";

const ALL = "__all__";

const ACTION_LABEL = { create: "Creazione", update: "Modifica", delete: "Eliminazione", import: "Import" };
const ACTION_STYLE = {
  create: "bg-emerald-50 text-emerald-700",
  update: "bg-blue-50 text-blue-700",
  delete: "bg-rose-50 text-rose-700",
  import: "bg-blue-50 text-blue-800",
};
const ENTITY_LABEL = {
  riga: "Contabilità", riga_subappalto: "Contabilità (subappalto)", benestare: "Benestare",
};

const fmtDateTime = (v) => {
  if (!v) return "—";
  const d = new Date(v);
  if (isNaN(d)) return "—";
  const p = (n) => String(n).padStart(2, "0");
  return `${p(d.getDate())}-${p(d.getMonth() + 1)}-${d.getFullYear()} · ${p(d.getHours())}:${p(d.getMinutes())}`;
};

export default function Attivita() {
  const [items, setItems] = useState([]);
  const [entity, setEntity] = useState("");

  const load = useCallback(() => {
    const params = {};
    if (entity) params.entity = entity;
    api.get("/activity", { params }).then((r) => setItems(r.data)).catch(() => {});
  }, [entity]);
  useEffect(() => { load(); }, [load]);

  const columns = [
    { id: "data", label: "Data e ora", width: 210, sortable: true, sortValue: (a) => a.timestamp || "",
      cell: (a) => <span className="text-slate-500 tabular-nums text-sm">{fmtDateTime(a.timestamp)}</span> },
    { id: "utente", label: "Utente", width: 200, sortable: true, sortValue: (a) => a.user_name || a.user_email || "",
      cell: (a) => <span className="font-medium text-slate-800">{a.user_name || a.user_email}</span> },
    { id: "azione", label: "Azione", width: 150, sortable: true, sortValue: (a) => ACTION_LABEL[a.action] || a.action || "",
      cell: (a) => <span className={`inline-flex px-2 py-0.5 rounded-full text-xs font-medium ${ACTION_STYLE[a.action] || "bg-slate-100 text-slate-600"}`}>{ACTION_LABEL[a.action] || a.action}</span> },
    { id: "tipo", label: "Tipo", width: 180, sortable: true, sortValue: (a) => ENTITY_LABEL[a.entity] || a.entity || "",
      cell: (a) => <span className="text-slate-600">{ENTITY_LABEL[a.entity] || a.entity}</span> },
    { id: "dettaglio", label: "Dettaglio", width: 360, sortable: true, sortValue: (a) => a.description || "",
      cell: (a) => <span className="text-slate-600">{a.description || "—"}</span> },
  ];

  return (
    <>
      

      <div className="flex-1 overflow-auto px-6 py-6 lg:px-8 space-y-5">
        <PageHeader title="Log attività" subtitle="Tracciabilità di inserimenti, modifiche ed eliminazioni" />
        <div className="w-72">
          <Label className="text-xs font-semibold uppercase tracking-widest text-slate-500">Filtra per tipo</Label>
          <Select value={entity || ALL} onValueChange={(v) => setEntity(v === ALL ? "" : v)}>
            <SelectTrigger data-testid="activity-filter-entity" className="mt-1.5 bg-white"><SelectValue /></SelectTrigger>
            <SelectContent>
              <SelectItem value={ALL}>Tutte le attività</SelectItem>
              <SelectItem value="riga">Contabilità</SelectItem>
              <SelectItem value="riga_subappalto">Contabilità (subappalto)</SelectItem>
              <SelectItem value="benestare">Benestare</SelectItem>
            </SelectContent>
          </Select>
        </div>

        <div className="bg-white rounded-md border border-slate-200 shadow-sm overflow-hidden" data-testid="activity-table">
          <DataTable tableKey="attivita" columns={columns} rows={items} rowKey={(a) => a.id}
            rowTestId={(a) => `activity-row-${a.id}`} emptyText="Nessuna attività registrata."
            containerClassName="max-h-[calc(100vh-260px)]" initialSort={{ key: "data", dir: "desc" }} />
        </div>
      </div>
    </>
  );
}
